module.exports = __webpack_public_path__ + "media/images/flags/1x1/mus-57e71f5153d8d0fb601f84de10ee5ea9.svg";